var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    {
      screentest: _vm.$store.state.Screentest.isScreentest,
      screentest_graphs: this.$route.query.screentest_graphs,
    },
    _vm.UserAgent.browser.name,
    _vm.UserAgent.browser.os,
  ],attrs:{"id":"app"}},[_c('img',{staticStyle:{"position":"fixed","left":"-1px","top":"-1px","opacity":"0"},attrs:{"src":'https://ad.doubleclick.net/ddm/trackimp/N7437.3434815PRIHEALTHCARESOLUTI/B26953163.323396948;dc_trk_aid=519953010;dc_trk_cid=165920516;ord=' + _vm.timestamp + ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=?',"alt":"Advertisement"}}),_c('router-view'),_c('transition',{attrs:{"name":"fade"}},[(
        this.UserAgent.orientation === 'landscape' &&
        this.UserAgent.window.width <= 1180
      )?_c('rotate-lock'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }